import { legacy_createStore, combineReducers } from "redux";
import reducer from "./reducer";

const rootReducer = combineReducers({ booking: reducer });

const store = legacy_createStore(rootReducer);

export default store;
